module.exports = __webpack_public_path__ + "img/identity-front.353409a3.png";